import { render, staticRenderFns } from "./Stage1.vue?vue&type=template&id=724f5ef7&scoped=true&"
import script from "./Stage1.vue?vue&type=script&lang=js&"
export * from "./Stage1.vue?vue&type=script&lang=js&"
import style0 from "./Stage1.vue?vue&type=style&index=0&id=724f5ef7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724f5ef7",
  null
  
)

export default component.exports